import { ReactElement, Fragment } from 'react';

import { RenderingSectionGroup } from '@zinnia/form-engine-sdk';

import { SectionGroup } from './SectionGroup';

type SectionGroupsProps = {
  sectionGroups: RenderingSectionGroup[];
};

export function SectionGroups(props: SectionGroupsProps): ReactElement | null {
  const { sectionGroups } = props;
  return (
    <Fragment>
      {sectionGroups.map((sectionGroup: RenderingSectionGroup) => (
        <SectionGroup key={sectionGroup.id} sectionGroup={sectionGroup} />
      ))}
    </Fragment>
  );
}
